import Vue from 'vue';
Vue.component('curriculum-nav-link', {
  props: ['document', 'selectedDocument'],
  methods: {
    navigate: function () {
      this.$emit('navigate', this.$props.document.uuid);
    },
  },
  computed: {
    isSelected: function () {
      if (this.selectedDocument) {
        return this.document.uuid == this.selectedDocument.uuid;
      } else {
        return false;
      }
    },
    checkCount: function () {
      let sum = 0;
      for (var i = 0; i < this.document.abilities.length; i++) {
        if (this.document.abilities[i].checked) {
          sum += 1;
        }
      }
      for (var i = 0; i < this.document.content.length; i++) {
        for (var j = 0; j < this.document.content[i].items.length; j++) {
          if (this.document.content[i].items[j].checked) {
            sum += 1;
          }
        }
      }
      return sum;
    },
  },
  template: `
    <a href="#" class="lp--curriculumMenuItem" v-bind:class="{selected: isSelected}" v-on:click="navigate">
      {{document.name}} {{document.meta_section}}<span class="lp--curriculumMenuItemCount">{{checkCount}}</span>
    </a>
  `,
});

Vue.component('curriculum-menu', {
  props: ['documents', 'selectedDocument', 'editMode', 'shouldDisplayOverview'],
  methods: {
    navigate: function (e) {
      this.$emit('navigate', e);
    },
    addDocument: function () {
      this.$emit('addDocument');
    },
    seeOverview: function () {
      this.$emit('navigate', null);
    },
    i18n: function (str) {
      return i18n.__(str);
    },
  },
  computed: {
    hasDocuments: function () {
      return this.$props.documents.length > 0;
    },
    isOverview: function () {
      return !this.selectedDocument;
    },
  },
  template: `
    <div class="lp--curriculumMenu">
      <a href="#" v-if="hasDocuments && shouldDisplayOverview" v-on:click="seeOverview" class="lp--curriculumMenuItem" v-bind:class="{selected: isOverview}">
        {{i18n('curriculum_picker_overview')}}
      </a>
      <curriculum-nav-link v-for="document in documents" :document="document" :selectedDocument="selectedDocument"  v-on:navigate="navigate"></curriculum-nav-link>
      <a href="#" v-if="editMode" class="lp--curriculumMenuItem lp--curriculumAddItem lp--js-curriculumAddSubject" v-on:click="addDocument">
        {{i18n('curriculum_picker_add_subject')}}
      </a>
    </div>
  `,
});

Vue.component('curriculum-tag-item', {
  props: ['item', 'editMode'],
  methods: {
    itemToggled: function () {
      this.item.checked = !this.item.checked;
      this.$emit('itemToggled', this.item);
    },
  },
  computed: {
    readOnly: function () {
      return !this.editMode;
    },
  },
  template: `
  <li class="lp--curriculumListItem" v-on:keyup.enter="itemToggled">
    <label v-bind:tabindex="readOnly ? -1 : 0" class="lp--curriculumListItemLabel">            
      <input tabindex="-1" type="checkbox" class="lp--curriculumItemCheckbox lp--js-curriculumAbilityCheckbox" v-bind:disabled="readOnly" v-bind:checked="item.checked" v-on:change="itemToggled" />
      <p v-html="item.content">
      </p>
    </label>
  </li>
  `,
});

Vue.component('curriculum-editor-placeholder', {
  props: ['searchMode'],
  template: `
    <div class="lp--curriculumEditorDocumentPlaceholder">
      {{placeholder}}
    </div>
  `,
  computed: {
    placeholder: function () {
      if (this.searchMode) {
        return i18n.__('curriculum_search_placeholder');
      } else {
        return i18n.__('curriculum_picker_placeholder');
      }
    },
  },
});

Vue.component('curriculum-viewer-placeholder', {
  props: ['type'],
  template: `
    <div class="lp--curriculumEditorDocumentPlaceholder">
      {{label}}
    </div>
  `,
  computed: {
    label: function () {
      if (this.type == 'collection') {
        return i18n.__('curriculum_collection_picker_empty');
      } else {
        return i18n.__('curriculum_picker_empty');
      }
    },
  },
});

Vue.component('curriculum-overview', {
  props: ['documents', 'editMode'],
  methods: {
    hasAnyTagsInSection: function (section, doc) {
      for (var j = 0; j < doc[section].length; j++) {
        for (var i = 0; i < doc[section][j].items.length; i++) {
          if (doc[section][j].items[i].checked) {
            return true;
          }
        }
      }
      return false;
    },
    sectionHasTags: function (section) {
      for (var j = 0; j < section.items.length; j++) {
        if (section.items[j].checked) {
          return true;
        }
      }
      return false;
    },
    hasAnyTags: function (section, doc) {
      for (var j = 0; j < doc[section].length; j++) {
        if (doc[section][j].checked) {
          return true;
        }
      }
      return false;
    },
    i18n: function (str) {
      return i18n.__(str);
    },
    toggleContextMode: function (document) {
      this.contextMode = !this.contextMode;
      this.$emit('toggleContext', document.uuid);
    },
  },
  computed: {
    taggedDocuments: function () {
      let doc = this.documents.filter(function (doc) {
        for (var j = 0; j < doc.abilities.length; j++) {
          if (doc.abilities[j].checked) {
            return true;
          }
        }
        for (var j = 0; j < doc.content.length; j++) {
          for (var k = 0; k < doc.content[j].items.length; k++) {
            if (doc.content[j].items[k].checked) {
              return true;
            }
          }
        }
        return false;
      });
      return doc;
    },
    contextText: function () {
      return this.contextMode ? i18n.__('curriculum_picker_hide_context') : i18n.__('curriculum_picker_show_context');
    },
  },
  data: function () {
    return {
      contextMode: false,
    };
  },
  template: `
  <section class="lp--curriculumOverview">
    <section class="lp--curriculumDocument" v-for="document in taggedDocuments">    
      <header class="lp--curriculumDocumentHeader">
        <h2>{{document.name}}</h2>
        <a href="#" class="lp--curriculumDocumentContextLink" v-on:click="toggleContextMode(document)" v-if="!editMode">{{contextText}}</a>
      </header>
      <section class="lp--curriculumDocumentAbilities lp--curriculumDocumentSection" v-if="hasAnyTags('abilities', document)">
        <header class="lp--curriculumDocumentSectionHeader">
          <h3>{{i18n('curriculum_picker_ability_title')}}</h3>
        </header>
        <ol class="lp--curriculumList">
          <curriculum-tag-item v-for="ability in document.abilities" :item="ability" v-if="ability.checked" :editMode="false"></curriculum-tag-item>
        </ol>
      </section>
      <section class="lp--curriculumDocumentContent lp--curriculumDocumentSection" v-if="hasAnyTagsInSection('content', document)">
        <header class="lp--curriculumDocumentSectionHeader">
          <h3>{{i18n('curriculum_picker_content_title')}}</h3>
        </header>
        <ol class="lp--curriculumList">
        <template v-for="section in document.content" v-if="sectionHasTags(section)">
          <li class="lp--curriculumListSectionHeader">
            <h3 class="lp--curriculumListSectionHeaderTitle" v-if="section.name">{{section.name}}</h3>
          </li>
          <curriculum-tag-item v-for="item in section.items" :item="item" v-if="item.checked" :editMode="false"></curriculum-tag-item>
        </template>
        </ol>
      </section>
    </section>
  </section
  `,
});

Vue.component('expandable-text', {
  props: ['text'],
  computed: {
    currentText: function () {
      if (this.expanded) {
        return this.text;
      } else {
        return this.text.substr(0, 160) + '...';
      }
    },
  },
  methods: {
    toggle: function () {
      this.expanded = !this.expanded;
    },
  },
  template: `
    <div tabindex="0" v-on:click="toggle" v-on:keyup.enter="toggle" class="lp--curriculumExpandableText" v-html="currentText"></div>
  `,
  data: function () {
    return {
      expanded: false,
    };
  },
});

Vue.component('curriculum-document', {
  props: ['currentDocument', 'editMode', 'contextMode'],
  methods: {
    abilityChanged: function (item) {
      this.tagChanged('abilities', item);
    },
    contentChanged: function (item) {
      this.tagChanged('content', item);
    },
    tagChanged: function (section, item) {
      this.$emit('taggingChanged', this.currentDocument.id, section, item);
    },
    hasAnyTagsInSection: function (section, doc) {
      for (var j = 0; j < doc[section].length; j++) {
        for (var i = 0; i < doc[section][j].items.length; i++) {
          if (doc[section][j].items[i].checked) {
            return true;
          }
        }
      }
      return false;
    },
    hasAnyTags: function (section, doc) {
      for (var j = 0; j < doc[section].length; j++) {
        if (doc[section][j].checked) {
          return true;
        }
      }
      return false;
    },
    sectionHasTags: function (section) {
      for (var j = 0; j < section.items.length; j++) {
        if (section.items[j].checked) {
          return true;
        }
      }
      return false;
    },
    i18n: function (str) {
      return i18n.__(str);
    },
    toggleContextMode: function (ev) {
      $(ev.target).blur();
      this.contextMode = !this.contextMode;
    },
  },
  computed: {
    abilityDescription: function () {
      return i18n.__('curriculum_picker_ability_desc', this.currentDocument.name);
    },
    contentDescription: function () {
      return i18n.__('curriculum_picker_content_desc', this.currentDocument.name);
    },
    contextText: function () {
      return this.contextMode ? i18n.__('curriculum_picker_hide_context') : i18n.__('curriculum_picker_show_context');
    },
  },
  template: `<section class="lp--curriculumDocument">
    <header class="lp--curriculumDocumentHeader">
      <h2>{{currentDocument.name}}</h2>
      <a href="#" class="lp--curriculumDocumentContextLink" v-on:click="toggleContextMode" v-if="!editMode">{{contextText}}</a>
    </header>
    <section class="lp--curriculumDocumentDescription">
      <expandable-text :text="currentDocument.description"></expandable-text>
      <h3>{{i18n('curriculum_picker_subject_purpose')}}</h3>
      <expandable-text :text="currentDocument.purpose"></expandable-text>
    </section>
    <section class="lp--curriculumDocumentAbilities lp--curriculumDocumentSection" v-if="editMode || hasAnyTags('abilities', currentDocument) || contextMode">
      <header class="lp--curriculumDocumentSectionHeader">
        <h3>{{i18n('curriculum_picker_ability_title')}}</h3>
        <p>
          {{abilityDescription}}
        </p>        
      </header>
      <ol class="lp--curriculumList">
        <curriculum-tag-item v-for="ability in currentDocument.abilities" :item="ability" v-if="editMode || ability.checked || contextMode" :editMode="editMode" v-on:itemToggled="abilityChanged"></curriculum-tag-item>
      </ol>
    </section>
    <section class="lp--curriculumDocumentContent lp--curriculumDocumentSection" v-if="editMode || hasAnyTagsInSection('content', currentDocument) || contextMode">
      <header class="lp--curriculumDocumentSectionHeader">
        <h3>{{i18n('curriculum_picker_content_title')}}</h3>
        <p>
         {{contentDescription}}:   
        </p>        
      </header>
      <ol class="lp--curriculumList">
        <template v-for="section in currentDocument.content" v-if="editMode || sectionHasTags(section) || contextMode">
          <li class="lp--curriculumListSectionHeader">
            <h3 class="lp--curriculumListSectionHeaderTitle" v-if="section.name">{{section.name}}</h3>
          </li>
          <curriculum-tag-item v-for="item in section.items" :item="item" v-if="editMode || item.checked || contextMode" :editMode="editMode" v-on:itemToggled="contentChanged"></curriculum-tag-item>
        </template>
      </ol>
    </section>
  </section>  
  `,
});
